import { BankingDepositsData } from "../../types/bankingDeposits.type";
import EmptyFiscalDocumentAlert from "./EmptyFiscalDocumentAlert";
import MainFiscalDocument from "./MainFiscalDocument";

interface BankingDepositFiscalDocumentsProps {
  bankingDeposit: BankingDepositsData;
}

const BankingDepositFiscalDocuments = ({ bankingDeposit }: BankingDepositFiscalDocumentsProps) => {
  if (bankingDeposit.status !== "paid") {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-lg">
            Notas fiscais
          </p>
        </div>
      </div>

      {!bankingDeposit.main_fiscal_document && <EmptyFiscalDocumentAlert />}

      {bankingDeposit.main_fiscal_document && (
        <MainFiscalDocument fiscalDocument={bankingDeposit.main_fiscal_document} />
      )}
    </div>
  );
}

export default BankingDepositFiscalDocuments;
